import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import OverallTheme from '../Styles/OverallTheme'

const DynamicLineGraph = ({ data, labels, title }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const secondaryColors = Object.values(OverallTheme.palette.REAL.secondary);

  useEffect(() => {
    // Cleanup old chart instance if it exists
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    // Create new chart instance
    const ctx = chartRef.current.getContext("2d");
    chartInstance.current = new Chart(ctx, {
      type: "line",
      data: {
        labels: labels, // X-axis labels
        datasets: data.map((dataset, index) => {
            const color = secondaryColors[index % secondaryColors.length]; // Cycle through if needed
            return {
              label: dataset.label,
              data: dataset.data,
              borderColor: dataset.color || color,
              backgroundColor: dataset.color || color,
              fill: false,
              tension: 0.4,
            };
          }),
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: true,
            position: "top",
          },
          title: {
            display: !!title,
            text: title,
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "Rounds",
            },
          },
          y: {
            title: {
              display: true,
              text: "Values",
            },
          },
        },
      },
    });

    // Cleanup on component unmount
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data, labels, title]);

  return <canvas ref={chartRef}></canvas>;
};

export default DynamicLineGraph;
